import { defineComponent, ref } from 'vue';
export default defineComponent({
    name: 'DescriptionDialog',
    props: {
        description: {
            type: String,
            required: true
        },
        showDialog: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const show = ref(props.showDialog);
        return {
            show
        };
    }
});
